import { useStores } from "../../core/stores/rootStore";
import React, { useContext, useEffect, useState,useRef} from "react";
import { useNavigate } from 'react-router-dom';
import { observer } from "mobx-react";
import { useTranslation, Trans } from "react-i18next";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import Button from 'react-bootstrap/Button';
import Stack from 'react-bootstrap/Stack';
import Modal from 'react-bootstrap/Modal';
import ManagementTable from "./../tables/managementTable";
import { boolToYesNo, getUnits, stripHTML, setConfig, getConfig, getClientLongName, getPackageTypes } from "../../utils"
import cloneDeep from 'lodash/cloneDeep';
import Form from 'react-bootstrap/Form';
import FormFileUpload from "./../inputs/fileupload";

const PackageExpensesAdmin = () => {

    let navigate = useNavigate();
    const { utilsStore, packageExpenseStore }= useStores();
    const { packageExpenses, getAll, remove, duplicate, getAllWithOptions/*, setConfig, config*/, upload } = packageExpenseStore;
    const { getCurrencies, currencies } = utilsStore;
    const { t, i18n } = useTranslation();
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [isLoading, setIsLoading] = useState(false);
    const tableRef = useRef(null);

    useEffect(() => {
        Promise.all([getCurrencies()]);
    }, []);
  

    const onPageChange = (props) => {
        var newProps = cloneDeep(props);

        newProps.filterBy?.filters?.forEach(main => {
            main?.filters?.forEach(f => {
                if (f.field === "type") {
                    f.value = getPackageTypes()?.find(x => x.key === f.value)?.id;
                }               
            });
        });
        setIsLoading(true);
        getAllWithOptions(newProps/*props.page + 1, props.filter, props.sort*/).then(() => {
            setIsLoading(false);
        });
    }

    const [validated, setValidated] = useState(false);
    const handleUpload = (event) => {
        event.preventDefault();
        const form = event.currentTarget;

        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        } else {            
            var files = new FormData(event.target)?.getAll("file") ?? [];
            var data = new FormData();

            if (files && files?.length) {
                files?.forEach((f, i) => {
                    data.append(`file`, files[i])
                })
            }          
            
            upload(data).then(() => {
                setValidated(false);
                handleClose();
                tableRef?.current?.resetPage();                
            });
        }
        setValidated(true);
    }
    return (
        <span>
            <ManagementTable name={t('packageExpenses')} ref={tableRef} isLoading={isLoading}
            config={{
                size: getConfig("packageExpenses", "size"),
                dataState: getConfig("packageExpenses", "dataState")
            }}
                onColumnSizeChange={(c) => setConfig("packageExpenses", "size", c)}
                onDataStateChange={(c) => { setConfig("packageExpenses", "dataState", c) }}
                items={packageExpenses?.results} onPageChange={onPageChange} pageCount={packageExpenses?.pageCount} total={packageExpenses?.count} pageSize={packageExpenses?.pageSize} columns={
                    [
                        { name: "category",prop:"type", fn: (v) => getPackageTypes()?.find(x => x.id === v)?.name ?? "-", variant: "select", filterSelectOptions: getPackageTypes()?.map(x => { return { text: x.key, value: x.id?.toString() } }) },
                        /*{ prop: "nameEN" },
                        { prop: "nameFR" },*/
                        { name: "startDate", prop: "startDate", fn: (v) => `${v?.split("-")?.[1]}.${v?.split("-")?.[0]}`, type: "month", filter: "date" },
                        { name: "endDate", prop: "endDate", fn: (v) => v.length? `${v?.split("-")?.[1]}.${v?.split("-")?.[0]}`:"-", type: "month", filter: "date" },                        
                        { name: "company", fn: (v) => v?.name ?? "-" },
                        { name: "shortAmount", prop: "quantity", filter: "numeric", useFormat: { decimals: 2 } },                        
                    ]}            
            extraButtons={
                [
                    { text: t('edit'), icon: solid("pen-to-square"), onClick: (id) => { navigate(`./${id}`) } },                    
                    { text: t('delete'), icon: solid("trash"), onClick: (id) => { remove(id).then(() => { tableRef?.current?.resetPage() }) }, modalText: t("confirmDelete"), modalTitle: t("delete"), danger: true }
                ]
            }
            />
        </span>

    );

   
};

export default observer(PackageExpensesAdmin);
